import type { Dialect, ParamWithMeta, SqlFragment } from './types'

/**
 * Represents a SQL condition (WHERE clause component) that can be serialized
 * with parameterized values.
 */
export class Condition implements SqlFragment {
  constructor(
    private readonly sqlTemplate: string | SqlFragment, // e.g., '"users"."id" = $PARAM'
    private readonly values: ParamWithMeta[] = [], // e.g., [{ value: '123', columnName: 'id' }]
  ) {}

  /**
   * Converts the condition to SQL with parameters.
   *
   * @param paramOffset - Starting parameter index (1-based for postgres)
   * @param dialect - SQL dialect for parameter placeholder format (default: postgres)
   */
  toSQL(
    paramOffset: number,
    dialect: Dialect = 'postgres',
  ): { sql: string; params: ParamWithMeta[] } {
    if (typeof this.sqlTemplate !== 'string') {
      return this.sqlTemplate.toSQL(paramOffset, dialect)
    }

    let sql = this.sqlTemplate
    let paramNum = paramOffset

    if (dialect === 'sqlite' || dialect === 'snowflake') {
      sql = sql.replaceAll('$PARAM', '?')
    } else {
      sql = sql.replaceAll('$PARAM', () => `$${paramNum++}`)
    }

    return { sql, params: this.values }
  }

  /**
   * Creates a condition that always evaluates to FALSE
   * Used internally by inArray([]) to return no results
   */
  static false(): Condition {
    return new Condition('FALSE', [])
  }
}
